import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';

import { SharedServicesModule } from '../../../../shared/services/shared.services.module';
import { SsvSelectPanelsWidget } from './ssv-select-panels-widget.component';

@NgModule({
  declarations: [SsvSelectPanelsWidget],
  imports: [
    CommonModule,
    SharedServicesModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    MatListModule,
    FormsModule,
  ],
  exports: [SsvSelectPanelsWidget],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SsvSelectPanelsWidgetModule {}
